import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';

export const tryToFetchBrandingConfig = (
    hotelUsername: string,
    type: string,
): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(
        `${DEVICE_INFO_API_URL}/branding-configs/${hotelUsername}/${type}`,
    );
};

export const tryToPatchBrandingConfig = (
    hotelUsername: string,
    type: string,
    data: any,
): Promise<AxiosResponse<any>> => {
    return brokersAxios.patch(
        `${DEVICE_INFO_API_URL}/branding-configs/${hotelUsername}/${type}`,
        { metadata: data },
    );
};
